module.exports = __webpack_public_path__ + "static/pensjonat-jesien_thumb-23b9f798ec2b0aaeef651ded22b359c7.jpg";